var _g, _mask, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 72,
    viewBox: "0 0 69 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1425_10350)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 34.1569,
    cy: 34.1569,
    r: 34.1569,
    fill: "#C91A1A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.1569,
    cy: 34.1569,
    r: 32.6569,
    stroke: "white",
    strokeWidth: 3
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_1425_10350",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.4756 21.2322C46.4818 19.1543 43.1809 19.0861 41.1029 21.08L34.1881 27.715L27.5535 21.3488C25.4755 19.3549 22.1747 19.4231 20.1808 21.501C18.1869 23.579 18.2551 26.8799 20.333 28.8738L26.6568 34.9416L20.2604 41.0791C18.1825 43.073 18.1143 46.3738 20.1082 48.4518C22.1021 50.5298 25.4029 50.5979 27.4809 48.604L34.1881 42.1682L41.1756 48.8729C43.2535 50.8667 46.5544 50.7986 48.5483 48.7206C50.5421 46.6426 50.474 43.3418 48.396 41.3479L41.7195 34.9416L48.3234 28.6049C50.4014 26.6111 50.4695 23.3102 48.4756 21.2322Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.4756 21.2322C46.4818 19.1543 43.1809 19.0861 41.1029 21.08L34.1881 27.715L27.5535 21.3488C25.4755 19.3549 22.1747 19.4231 20.1808 21.501C18.1869 23.579 18.2551 26.8799 20.333 28.8738L26.6568 34.9416L20.2604 41.0791C18.1825 43.073 18.1143 46.3738 20.1082 48.4518C22.1021 50.5298 25.4029 50.5979 27.4809 48.604L34.1881 42.1682L41.1756 48.8729C43.2535 50.8667 46.5544 50.7986 48.5483 48.7206C50.5421 46.6426 50.474 43.3418 48.396 41.3479L41.7195 34.9416L48.3234 28.6049C50.4014 26.6111 50.4695 23.3102 48.4756 21.2322Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1029 21.08L41.7953 21.8015V21.8015L41.1029 21.08ZM48.4756 21.2322L49.1972 20.5399L49.1972 20.5399L48.4756 21.2322ZM34.1881 27.715L33.4958 28.4365L34.1881 29.1009L34.8805 28.4365L34.1881 27.715ZM27.5535 21.3488L26.8611 22.0704L27.5535 21.3488ZM20.1808 21.501L19.4592 20.8087L20.1808 21.501ZM20.333 28.8738L21.0254 28.1522L20.333 28.8738ZM26.6568 34.9416L27.3491 35.6631L28.1011 34.9416L27.3491 34.22L26.6568 34.9416ZM20.2604 41.0791L20.9528 41.8006L20.2604 41.0791ZM20.1082 48.4518L19.3866 49.1441H19.3866L20.1082 48.4518ZM27.4809 48.604L26.7885 47.8825L27.4809 48.604ZM34.1881 42.1682L34.8805 41.4466L34.1881 40.7823L33.4958 41.4466L34.1881 42.1682ZM41.1756 48.8729L41.8679 48.1513L41.1756 48.8729ZM48.396 41.3479L49.0884 40.6263L48.396 41.3479ZM41.7195 34.9416L41.0272 34.22L40.2752 34.9416L41.0272 35.6631L41.7195 34.9416ZM48.3234 28.6049L47.631 27.8834H47.631L48.3234 28.6049ZM41.7953 21.8015C43.4747 20.19 46.1426 20.2451 47.7541 21.9246L49.1972 20.5399C46.8209 18.0634 42.887 17.9822 40.4106 20.3584L41.7953 21.8015ZM34.8805 28.4365L41.7953 21.8015L40.4106 20.3584L33.4958 26.9934L34.8805 28.4365ZM34.8805 26.9934L28.2459 20.6272L26.8611 22.0704L33.4958 28.4365L34.8805 26.9934ZM28.2459 20.6272C25.7694 18.251 21.8355 18.3322 19.4592 20.8087L20.9023 22.1934C22.5138 20.5139 25.1817 20.4589 26.8611 22.0704L28.2459 20.6272ZM19.4592 20.8087C17.083 23.2852 17.1642 27.2191 19.6407 29.5953L21.0254 28.1522C19.3459 26.5407 19.2909 23.8729 20.9023 22.1934L19.4592 20.8087ZM19.6407 29.5953L25.9644 35.6631L27.3491 34.22L21.0254 28.1522L19.6407 29.5953ZM20.9528 41.8006L27.3491 35.6631L25.9644 34.22L19.5681 40.3575L20.9528 41.8006ZM20.8297 47.7594C19.2182 46.08 19.2733 43.4121 20.9528 41.8006L19.5681 40.3575C17.0916 42.7338 17.0104 46.6677 19.3866 49.1441L20.8297 47.7594ZM26.7885 47.8825C25.1091 49.494 22.4412 49.4389 20.8297 47.7594L19.3866 49.1441C21.7629 51.6206 25.6968 51.7018 28.1732 49.3256L26.7885 47.8825ZM33.4958 41.4466L26.7885 47.8825L28.1732 49.3256L34.8805 42.8898L33.4958 41.4466ZM33.4958 42.8898L40.4832 49.5944L41.8679 48.1513L34.8805 41.4466L33.4958 42.8898ZM40.4832 49.5944C42.9597 51.9707 46.8936 51.8894 49.2698 49.413L47.8267 48.0282C46.2152 49.7077 43.5474 49.7628 41.8679 48.1513L40.4832 49.5944ZM49.2698 49.413C51.6461 46.9365 51.5648 43.0026 49.0884 40.6263L47.7036 42.0695C49.3831 43.6809 49.4382 46.3488 47.8267 48.0282L49.2698 49.413ZM49.0884 40.6263L42.4119 34.22L41.0272 35.6631L47.7036 42.0695L49.0884 40.6263ZM47.631 27.8834L41.0272 34.22L42.4119 35.6631L49.0158 29.3265L47.631 27.8834ZM47.7541 21.9246C49.3656 23.604 49.3105 26.2719 47.631 27.8834L49.0158 29.3265C51.4922 26.9502 51.5735 23.0163 49.1972 20.5399L47.7541 21.9246Z",
    fill: "#990B0B",
    mask: "url(#path-3-inside-1_1425_10350)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1425_10350",
    x: 0,
    y: 0,
    width: 68.3125,
    height: 71.3137,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6 0 0 0 0 0.0425 0 0 0 0 0.0425 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1425_10350"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1425_10350",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBtn);
export default __webpack_public_path__ + "static/media/close_btn.e2ed4606bedba46b466e211f6ebf5c96.svg";
export { ForwardRef as ReactComponent };